export const REGEX_FOR_EMAIL = new RegExp(/^([a-zA-Z0-9._-]+[A-Za-z0-9])?@[A-Za-z0-9-]+\.[A-Za-z.]{2,10}$/);
// export const REGEX_FOR_URL = new RegExp(/^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/);
// export const REGEX_FOR_DEFAULT = new RegExp(/^[a-zA-Z0-9\-.,;:_&\s]+$/);
// export const REGEX_FOR_NAME = new RegExp(/^[a-zA-Z0-9\-.,;:_\s]+$/);
// export const REGEX_FOR_CODE = new RegExp(/^[a-zA-Z0-9_-]+$/);


export function validateEmail(email) {
    // let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-7]{1,3}\.[0-7]{1,3}\.[0-7]{1,3}\.[0-7]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return REGEX_FOR_EMAIL.test(email);
}
